/* LURE theme - minimal vanilla JS */
(function () {
  'use strict';

  /* Mobile menu ---------------------------------------------------------- */
  var menu = document.querySelector('[data-mobile-menu]');
  var burger = document.querySelector('.header__burger');
  if (menu && burger) {
    var setOpen = function (open) {
      menu.hidden = !open;
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('menu-open', open);
      if (open) {
        var first = menu.querySelector('a, button');
        if (first) first.focus();
      } else {
        burger.focus();
      }
    };
    document.querySelectorAll('[data-menu-toggle]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(menu.hidden); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) setOpen(false);
    });
  }

  /* Money formatting (uses Shopify.formatMoney when available) ------------ */
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    var el = document.querySelector('[data-price-current]');
    var sample = el ? el.textContent.trim() : '';
    var value = (cents / 100).toFixed(2).replace('.', ',');
    // Try to keep the currency placement the store renders on the server.
    if (/^[^\d]+/.test(sample) && !/[^\d\s.,]+$/.test(sample)) return sample.replace(/[\d.,]+/, value);
    if (/[^\d\s.,]+$/.test(sample)) return sample.replace(/[\d.,]+/, value);
    return value;
  }

  /* Product: variants + gallery ------------------------------------------- */
  document.querySelectorAll('[data-product]').forEach(function (section) {
    var jsonEl = section.querySelector('[data-product-json]');
    var form = section.querySelector('[data-product-form]');
    if (!jsonEl || !form) return;
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-variant-id]');
    var atc = form.querySelector('[data-atc]');
    var atcText = form.querySelector('[data-atc-text]');
    var priceEl = section.querySelector('[data-price-current]');
    var compareEl = section.querySelector('[data-price-compare]');
    var strings = {
      add: atcText ? atcText.textContent.trim() : 'Dodaj u korpu',
      soldOut: (window.theme && window.theme.strings && window.theme.strings.soldOut) || 'Rasprodano',
      unavailable: (window.theme && window.theme.strings && window.theme.strings.unavailable) || 'Nedostupno'
    };
    if (atc && atc.disabled) strings.add = (window.theme && window.theme.strings && window.theme.strings.addToCart) || 'Dodaj u korpu';

    function selectedOptions() {
      var opts = [];
      section.querySelectorAll('.product__option').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function markAvailability(opts) {
      section.querySelectorAll('.product__option').forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice();
          test[idx] = input.value;
          var v = findVariant(test);
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      markAvailability(opts);
      if (!variant) {
        if (atc) atc.disabled = true;
        if (atcText) atcText.textContent = strings.unavailable;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (atc) atc.disabled = !variant.available;
      if (atcText) atcText.textContent = variant.available ? strings.add : strings.soldOut;

      if (variant.featured_media && variant.featured_media.id) showMedia(String(variant.featured_media.id));

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    section.querySelectorAll('[data-option-value]').forEach(function (input) {
      input.addEventListener('change', update);
    });

    /* Gallery */
    var medias = section.querySelectorAll('[data-media]');
    var thumbs = section.querySelectorAll('[data-thumb]');
    function showMedia(id) {
      medias.forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-media-id') === id); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === id); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-media-id')); });
    });
    var next = section.querySelector('[data-thumb-next]');
    if (next && thumbs.length) {
      next.addEventListener('click', function () {
        var i = Array.prototype.findIndex.call(thumbs, function (t) { return t.classList.contains('is-active'); });
        var n = thumbs[(i + 1) % thumbs.length];
        showMedia(n.getAttribute('data-media-id'));
      });
    }

    /* Swipe on main image (mobile) */
    var main = section.querySelector('.product__main-media');
    if (main && thumbs.length > 1) {
      var startX = null;
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        var i = Array.prototype.findIndex.call(thumbs, function (t) { return t.classList.contains('is-active'); });
        var n = thumbs[(i + (dx < 0 ? 1 : thumbs.length - 1)) % thumbs.length];
        showMedia(n.getAttribute('data-media-id'));
      }, { passive: true });
    }

    /* Ensure a size is selected before submit when nothing is checked */
    form.addEventListener('submit', function (e) {
      var opts = selectedOptions();
      if (opts.some(function (o) { return o === null; })) {
        e.preventDefault();
        var firstEmpty = section.querySelector('.product__option input');
        if (firstEmpty) firstEmpty.focus();
      }
    });
  });

  /* Cart --------------------------------------------------------------- */
  var cart = document.querySelector('[data-cart]');
  if (cart) {
    var changeLine = function (line, quantity) {
      cart.classList.add('is-loading');
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () { window.location.reload(); })
        .catch(function () { cart.classList.remove('is-loading'); });
    };

    cart.querySelectorAll('.cart-item').forEach(function (item) {
      var line = parseInt(item.getAttribute('data-line'), 10);
      var input = item.querySelector('[data-qty-input]');
      var minus = item.querySelector('[data-qty-minus]');
      var plus = item.querySelector('[data-qty-plus]');
      var remove = item.querySelector('[data-remove]');
      if (minus) minus.addEventListener('click', function () { changeLine(line, Math.max(0, parseInt(input.value, 10) - 1)); });
      if (plus) plus.addEventListener('click', function () { changeLine(line, parseInt(input.value, 10) + 1); });
      if (input) input.addEventListener('change', function () { changeLine(line, Math.max(0, parseInt(input.value, 10) || 0)); });
      if (remove) remove.addEventListener('click', function (e) { e.preventDefault(); changeLine(line, 0); });
    });
  }
})();
